/**
 * Цвета знака платформы Aseller — фирменные, а не семантические: логотип одинаков в
 * светлой и тёмной теме, поэтому это не роли `appColors`, а константы бренда. Живут
 * здесь, потому что каталог темы — единственное место, где цвет вправе быть значением
 * (`__tests__/noHardcodedColors.test.ts`).
 */
export const ASELLER_MARK_COLORS = {
  green: '#19b14a',
  blue: '#1677ff',
  yellow: '#f5cf00',
} as const;
